/**
 * 公共参数的配置文件
 * **/

var pssApi = {
  // 登录相关接口
  getPicRandomCode: "/pss/getPicRandomCode", // 获取图片验证码
  getVerificationCode: "/pss/getVerificationCode", // 获取短信验证码
  login: "/pss/login", // 登录
  register:"/pss/register", // 注册
  findPwd: "/pss/findPwd ", // 找回密码
    
  // 设备相关接口
  bindDevice: "/pss/bindDevice", // 绑定设备
  getDeviceMsg: "/pss/getDeviceMsg", // 查询设备里面的卡信息
  accountDevice: "/pss/accountDevice", // 查询绑定关系
  shareFlow: "/pss/shareFlow", // 根据设备查询卡
  searchCard: "/pss/searchCard", // 查询卡详情
  confirmShare: "/pss/confirmShare", // 确认分享
  cancelShare: "/pss/cancelShare", // 取消分享
  unbindDevice: "/pss/unbindDevice", // 解绑设备
  getUserDeviceList: "/pss/getUserDeviceList", // 查询设备列表

  getShareTip: "/pss/getShareTip", // 分享提示

  // 提现相关接口
  userWithdrawCash: "/pss/userWithdrawCash", // 提现
  getUserBalance: "pss/getUserBalance", // 查询可提现金额
  searchUserHistoryOrder: "/pss/searchUserHistoryOrder", // 历史订单
  getUserWithdrawCashList: "/pss/getUserWithdrawCashList", // 提现记录

  // 字典
  queryDictionary: "/pss/queryDictionary", // 字典(参数type)

  // 预约码
  checkUserCode: "/pss/checkUserCode", // 校验是否已经授权
  validateUserCode: "/pss/validateUserCode", // 校验预约码是否正确
}

var config = {
    api : pssApi
}

export default config;




// WEBPACK FOOTER //
// ./src/config/config.js